import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/workOrder/${number | ':workOrderId'}`;

export const ROUTE: RouteDefinition = `${baseRoute}/workOrder/:workOrderId`;

export const URL = (workOrderId: number): RouteDefinition => `${baseRoute}/workOrder/${workOrderId}`;
